import React, { Component } from 'react'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import AccountApprovalRequired from '~/Common-Objects/Account/AccountApprovalRequired'

import SiteTrackingNav from './siteTrackingNav'
import TrackingUpsell from './upsell'

@connect((store) => {
    return { site: store.siteMaster, account: store.accountMaster }
})
class SiteTrackingTemplate extends Component {
    render() {
        if (this.props.hideTemplate) {
            return this.props.children
        }
        const account = this.props.account.accountMaster
        const needsApproval = account.deny || !account.approved
        return (
            <Paper>
                <div className='page-header mar-b25'>{i18n.t('campaigns:sitetracking.trackingsites.header')}</div>
                {this.props.tierAllowed.allowed ? (
                    <>
                        {needsApproval && (
                            <div className='mar-b25'>
                                <AccountApprovalRequired
                                    messageOrientation='left'
                                    notApprovedText='Approval is required to enable Site Tracking'
                                    inReviewText='Your account is under review'
                                    activateFrom='tracking'
                                />
                            </div>
                        )}
                        <SiteTrackingNav history={this.props.history} />
                        {this.props.children}
                    </>
                ) : (
                    <TrackingUpsell />
                )}
            </Paper>
        )
    }
}

export default SiteTrackingTemplate
